import { NavLink, useLocation } from "react-router-dom";
import { Map, Bell, User, Wallet } from "lucide-react";
import { motion } from "framer-motion";
import { cn } from "@/shared/lib/utils";
import { useHaptics } from "@/shared/hooks/useHaptics";
import { useNotifications } from "@/features/notifications/hooks/useNotifications";

interface NavItem {
  to: string;
  icon: React.ElementType;
  label: string;
}

const NAV_ITEMS: NavItem[] = [
  { to: "/app/map", icon: Map, label: "Karta" },
  { to: "/app/notifications", icon: Bell, label: "Notiser" },
  { to: "/app/wallet", icon: Wallet, label: "Plånbok" },
  { to: "/app/profile", icon: User, label: "Profil" },
];

export function BottomNav() {
  const location = useLocation();
  const { impact } = useHaptics();
  const { unreadCount } = useNotifications();

  return (
    <nav
      className={cn(
        "flex items-stretch justify-around",
        "glass-dark border-t border-white/[0.08]",
        "min-h-[49px]"
      )}
      style={{ paddingBottom: "max(env(safe-area-inset-bottom), 8px)" }}
    >
      {NAV_ITEMS.map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname.startsWith(item.to);

        return (
          <NavLink
            key={item.to}
            to={item.to}
            className="flex-1 flex flex-col items-center justify-center py-2 btn-press"
            onClick={() => impact("light")}
          >
            <div className="relative flex flex-col items-center gap-0.5">
              <div className="relative">
                <Icon
                  className={cn(
                    "w-6 h-6 transition-colors duration-200",
                    isActive ? "text-ios-blue" : "text-ios-label-secondary/50"
                  )}
                  strokeWidth={isActive ? 2.5 : 1.5}
                />
                {/* Unread badge on Bell icon */}
                {item.to === "/app/notifications" && unreadCount > 0 && (
                  <span className="absolute -top-1 -right-1 min-w-[16px] h-[16px] px-0.5 bg-red-500 rounded-full flex items-center justify-center text-[9px] font-bold text-white leading-none">
                    {unreadCount > 99 ? "99+" : unreadCount}
                  </span>
                )}
              </div>
              <span
                className={cn(
                  "text-[10px] font-medium transition-colors duration-200",
                  isActive ? "text-ios-blue" : "text-ios-label-secondary/50"
                )}
              >
                {item.label}
              </span>
              {isActive && (
                <motion.div
                  layoutId="tab-indicator"
                  className="absolute -top-1 w-1 h-1 rounded-full bg-ios-blue"
                  transition={{ type: "spring", stiffness: 500, damping: 30 }}
                />
              )}
            </div>
          </NavLink>
        );
      })}
    </nav>
  );
}
